import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { LOGIN_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds';
export const newRoutes = {
    [routeUrls.giveawayHistory()]: {
        url: routeUrls.giveawayHistory(),
        modules: [],
    },
    [routeUrls.giveawayRewards()]: {
        url: routeUrls.giveawayRewards(),
        modules: [],
    },
    [routeUrls.drops()]: {
        url: routeUrls.drops(),
        modules: [],
    },
    [routeUrls.audienceTargeting()]: {
        url: routeUrls.audienceTargeting(),
        modules: [],
    },
    [routeUrls.reviewClips()]: {
        url: routeUrls.reviewClips(),
        modules: [],
    },
    [routeUrls.brandUsers()]: {
        url: routeUrls.brandUsers(),
        modules: [],
    },
    '/creators/:id': {
        url: '/creators/:id',
        modules: [],
    },
    '/creators/yt/:id': {
        url: '/creators/yt/:id',
        modules: [],
    },
    '/creators/tiktok/:id': {
        url: '/creators/tiktok/:id',
        modules: [],
    },
    [routeUrls.addCampaign()]: {
        url: routeUrls.addCampaign(),
        modules: [],
    },
    [routeUrls.steamSales()]: {
        url: routeUrls.steamSales(),
        modules: [],
    },
    [routeUrls.keysAndProducts()]: {
        url: routeUrls.keysAndProducts(),
        modules: [],
    },
    '/battle-passes/:id': {
        url: '/battle-passes/:id',
        modules: [],
    },
    [routeUrls.battlePasses()]: {
        url: routeUrls.battlePasses(),
        modules: [],
    },
    [routeUrls.creatorDashboard()]: {
        url: routeUrls.creatorDashboard(),
    },
    [routeUrls.ambassadorProgram()]: {
        url: routeUrls.ambassadorProgram(),
        modules: [],
    },
    [routeUrls.creatorsLeaderboard()]: {
        url: routeUrls.creatorsLeaderboard(),
        modules: [],
    },
    [routeUrls.applications()]: {
        url: routeUrls.applications(),
        modules: [],
    },
    [routeUrls.application(':id')]: {
        url: routeUrls.application(':id'),
        modules: [],
    },
    [routeUrls.satisfactionSurvey()]: {
        url: routeUrls.satisfactionSurvey(),
        modules: [],
    },
    [routeUrls.authPopupCallback()]: {
        url: routeUrls.authPopupCallback(),
        modules: [],
    },
    [routeUrls.editCreatorDare(':id')]: {
        url: routeUrls.editCreatorDare(':id'),
        modules: [],
    },
    // Temporary design-system preview route. Safe to remove together with the page.
    '/design-preview': {
        url: '/design-preview',
        modules: [],
    },
    // Redesign preview of the Drops page. Remove together with the page when A/B is wired.
    '/nova/drops': {
        url: '/nova/drops',
        modules: [],
    },
    // Redesign preview of the single Drop page. Remove together with the page when A/B is wired.
    '/nova/drop/:recordId': {
        url: '/nova/drop/:recordId',
        modules: [],
    },
    // Redesign preview of the View Dare (project detail) page. Remove together with the page when A/B is wired.
    '/nova/dare/:recordId': {
        url: '/nova/dare/:recordId',
        modules: [],
    },
    // Redesign preview of the creator profile page. Remove together with the page when A/B is wired.
    '/nova/creators/:recordId': {
        url: '/nova/creators/:recordId',
        modules: [],
    },
    // Platform-specific creator profile twins (mirror the legacy `/creators/<platform>/:recordId`).
    '/nova/creators/twitch/:recordId': {
        url: '/nova/creators/twitch/:recordId',
        modules: [],
    },
    '/nova/creators/yt/:recordId': {
        url: '/nova/creators/yt/:recordId',
        modules: [],
    },
    '/nova/creators/tiktok/:recordId': {
        url: '/nova/creators/tiktok/:recordId',
        modules: [],
    },
    // Redesign preview of the Add Campaign page. Remove together with the page when A/B is wired.
    '/nova/add-campaign': {
        url: '/nova/add-campaign',
        modules: [],
    },
    // Redesign preview of the brand campaign dashboard (per-campaign). Remove together with the page when A/B is wired.
    '/nova/campaign-dashboard/:recordId': {
        url: '/nova/campaign-dashboard/:recordId',
        modules: [],
    },
    // Redesign preview of the brand campaign dashboard (aggregated summary). Remove together with the page when A/B is wired.
    '/nova/campaign-dashboard': {
        url: '/nova/campaign-dashboard',
        modules: [],
    },
    // `/nova` alias of the brand campaign dashboard demo, which now lives at `/demo-campaign-dashboard`
    // (see `demoDashboard.ts`). Auth mirrors that route exactly: brand-authenticated, so logged-out /
    // non-brand visitors are redirected to login.
    '/nova/demo-campaign-dashboard': {
        url: '/nova/demo-campaign-dashboard',
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.brand,
        defaultRouteId: LOGIN_ROUTE_ID,
        modules: [],
    },
    // Redesign preview of the brand campaign clips page (per-campaign). Remove together with the page when A/B is wired.
    '/nova/campaign-clips/:recordId': {
        url: '/nova/campaign-clips/:recordId',
        modules: [],
    },
    // Redesign preview of the brand campaign clips page (aggregated, all campaigns). Remove together with the page when A/B is wired.
    '/nova/campaign-clips': {
        url: '/nova/campaign-clips',
        modules: [],
    },
    // Redesign preview of the campaign creators list (per-campaign). Remove together with the page when A/B is wired.
    '/nova/campaign-creators/:recordId': {
        url: '/nova/campaign-creators/:recordId',
        modules: [],
    },
    // Redesign preview of the campaign creators list (aggregated, all campaigns). Remove together with the page when A/B is wired.
    '/nova/campaign-creators': {
        url: '/nova/campaign-creators',
        modules: [],
    },
    // Redesign preview of the Applications list page. Remove together with the page when A/B is wired.
    '/nova/applications': {
        url: '/nova/applications',
        modules: [],
    },
    // Redesign preview of the single Application page. Remove together with the page when A/B is wired.
    '/nova/application/:id': {
        url: '/nova/application/:id',
        modules: [],
    },
    // Redesign preview of the Brand Dares (publisher dares) page. Remove together with the page when A/B is wired.
    '/nova/publisher-dares': {
        url: '/nova/publisher-dares',
        modules: [],
    },
    // Redesign preview of the admin Pending Dares (pending-videos) page. Remove together with the page when A/B is wired.
    '/nova/pending-videos': {
        url: '/nova/pending-videos',
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        defaultRouteId: LOGIN_ROUTE_ID,
        modules: [],
    },
    // Redesign preview of the brand Approve Dares (brand-approve-dares) page. Remove together with the page when A/B is wired.
    '/nova/brand-approve-dares': {
        url: '/nova/brand-approve-dares',
        modules: [],
    },
    // Redesign preview of the admin Brand Reports (brands-reports) page. Remove together with the page when A/B is wired.
    '/nova/brands-reports': {
        url: '/nova/brands-reports',
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        defaultRouteId: LOGIN_ROUTE_ID,
        modules: [],
    },
    // Redesign preview of the brand Campaigns list page. Remove together with the page when A/B is wired.
    '/nova/campaigns': {
        url: '/nova/campaigns',
        modules: [],
    },
    // Redesign preview of the Brand Users (team management) page. Remove together with the page when A/B is wired.
    '/nova/brand-users': {
        url: '/nova/brand-users',
        modules: [],
    },
    // Redesign preview of the Whitelisted Creators page. Remove together with the page when A/B is wired.
    '/nova/whitelisted-creators': {
        url: '/nova/whitelisted-creators',
        modules: [],
    },
    // Redesign preview of the Banned Creators page. Remove together with the page when A/B is wired.
    '/nova/banned-creators': {
        url: '/nova/banned-creators',
        modules: [],
    },
    // Redesign preview of the Keys & Products page. Remove together with the page when A/B is wired.
    '/nova/keys-and-products': {
        url: '/nova/keys-and-products',
        modules: [],
    },
    // Redesign preview of the creator My Keys page. Remove together with the page when A/B is wired.
    '/nova/my-keys': {
        url: '/nova/my-keys',
        modules: [],
    },
    // Single reward page, the destination of every reward email link.
    // Intentionally NOT auth-gated: `checkAuthRedirect` sends signed-out visitors to the default route
    // without remembering where they were going, which would drop people arriving from an email. The page
    // renders its own sign-in prompt instead, and the code is protected by the reveal procedure.
    '/reward/:rewardId': {
        url: '/reward/:rewardId',
        modules: [],
    },
    // Redesign preview of the admin Drop campaigns page. Remove together with the page when A/B is wired.
    '/nova/drop-admin': {
        url: '/nova/drop-admin',
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        defaultRouteId: LOGIN_ROUTE_ID,
        modules: [],
    },
    // Redesign preview of the admin Ban admin page. Remove together with the page when A/B is wired.
    '/nova/ban-admin': {
        url: '/nova/ban-admin',
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        defaultRouteId: LOGIN_ROUTE_ID,
        modules: [],
    },
    // Redesign preview of the admin Featured Dares curation page. Remove together with the page when A/B is wired.
    '/nova/featured-dares': {
        url: '/nova/featured-dares',
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        defaultRouteId: LOGIN_ROUTE_ID,
        modules: [],
    },
    // `/nova` alias of the admin Coupons page, which now serves the redesign in place at `/coupon-admin`.
    '/nova/coupon-admin': {
        url: '/nova/coupon-admin',
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        defaultRouteId: LOGIN_ROUTE_ID,
        modules: [],
    },
    // Redesign preview of the admin Short URL analytics page. Remove together with the page when A/B is wired.
    '/nova/short-url-analytics': {
        url: '/nova/short-url-analytics',
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        defaultRouteId: LOGIN_ROUTE_ID,
        modules: [],
    },
    // `/nova` alias of the Steam sales lookup, which now serves the redesign in place at `/steam-sales`.
    // Both page files run the same `steamSalesGetServerSideProps` (brand or admin, else redirected), so
    // the alias is exactly as gated as the clean URL and needs no `authentication` here either.
    '/nova/steam-sales': {
        url: '/nova/steam-sales',
        modules: [],
    },
    // Redesign preview of the agency Account Managers page. Remove together with the page when A/B is wired.
    // Auth mirrors the legacy `/account-managers` route: agency-authenticated, so logged-out / non-agency
    // visitors are redirected (logged-out users to login).
    '/nova/account-managers': {
        url: '/nova/account-managers',
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.agency,
        defaultRouteId: LOGIN_ROUTE_ID,
        modules: [],
    },
    // Redesign preview of the creator dashboard. Remove together with the page when A/B is wired.
    '/nova/creator-dashboard': {
        url: '/nova/creator-dashboard',
        modules: [],
    },
    // Redesign preview of the creators leaderboard. Remove together with the page when A/B is wired.
    '/nova/creators-leaderboard': {
        url: '/nova/creators-leaderboard',
        modules: [],
    },
    // Redesign preview of the Community Reviews (clip review) page. Remove together with the page when A/B is wired.
    '/nova/review-clips': {
        url: '/nova/review-clips',
        modules: [],
    },
    // Redesign preview of the Audience Targeting page. Remove together with the page when A/B is wired.
    '/nova/audience-targeting': {
        url: '/nova/audience-targeting',
        modules: [],
    },
    // Redesign preview of the admin Review Dare (review-project) page. Remove together with the page when A/B is wired.
    '/nova/review-project/:recordId': {
        url: '/nova/review-project/:recordId',
        modules: [],
    },
    // Redesign preview of the brand Review Dare (review-drop-project) page. Remove together with the page when A/B is wired.
    '/nova/review-drop-project/:recordId': {
        url: '/nova/review-drop-project/:recordId',
        modules: [],
    },
    // Redesign preview of the Privacy Policy legal page. Remove together with the page when A/B is wired.
    '/nova/privacy-policy': {
        url: '/nova/privacy-policy',
        modules: [],
    },
    // Redesign preview of the Cookie Policy legal page. Remove together with the page when A/B is wired.
    '/nova/cookie-policy': {
        url: '/nova/cookie-policy',
        modules: [],
    },
    // Redesign preview of the Terms of Service legal page. Remove together with the page when A/B is wired.
    '/nova/terms': {
        url: '/nova/terms',
        modules: [],
    },
    // Redesign preview of the FAQ page. Remove together with the page when A/B is wired.
    '/nova/FAQ': {
        url: '/nova/FAQ',
        modules: [],
    },
    // Redesign twins of the auth pages (`/sign-in`, `/sign-up`). `unauthenticated` mirrors the legacy
    // routes, so a signed-in visitor is bounced to their group default route instead of being shown a
    // sign-in form. `/sign-in` also carries `noLoginRedirect`, which only matters on the legacy route
    // (it is the target of the auth bounce), so the aliases do not repeat it.
    '/nova/sign-in': {
        url: '/nova/sign-in',
        authentication: authenticationTypes.unauthenticated,
        modules: [],
    },
    '/nova/sign-up': {
        url: '/nova/sign-up',
        authentication: authenticationTypes.unauthenticated,
        modules: [],
    },
    // Redesign twins of the password and email-change flows. Each mirrors its legacy route's
    // authentication so an alias is never weaker than the clean URL. `noLoginRedirect` and `noSitemap`
    // are legacy-route concerns (the auth bounce target and the sitemap builder), so they are not
    // repeated here: the aliases are not linked from anywhere and not in the sitemap to begin with.
    '/nova/forgot-password': {
        url: '/nova/forgot-password',
        authentication: authenticationTypes.unauthenticated,
        modules: [],
    },
    '/nova/reset-password': {
        url: '/nova/reset-password',
        authentication: authenticationTypes.unauthenticated,
        modules: [],
    },
    '/nova/confirm-reset-password': {
        url: '/nova/confirm-reset-password',
        authentication: authenticationTypes.unauthenticated,
        modules: [],
    },
    '/nova/transfer-account': {
        url: '/nova/transfer-account',
        authentication: authenticationTypes.unauthenticated,
        modules: [],
    },
    '/nova/verify-new-email': {
        url: '/nova/verify-new-email',
        modules: [],
    },
    '/nova/email-verified': {
        url: '/nova/email-verified',
        authentication: authenticationTypes.authenticated,
        modules: [],
    },
    '/nova/email-verification-failure': {
        url: '/nova/email-verification-failure',
        modules: [],
    },
    '/nova/set-email-failure': {
        url: '/nova/set-email-failure',
        modules: [],
    },
    // Redesign twin of the post-signup "check your email" page (`/verify-account`). Static, no auth
    // (mirrors the legacy route, which has no authentication field either).
    '/nova/verify-account': {
        url: '/nova/verify-account',
        modules: [],
    },
    // Redesign twins of the account verification outcome pages. `unauthenticated` mirrors the legacy
    // routes exactly: a signed-in visitor is bounced to their group default route.
    '/nova/verify-account-finished': {
        url: '/nova/verify-account-finished',
        authentication: authenticationTypes.unauthenticated,
        modules: [],
    },
    '/nova/verify-account-failure': {
        url: '/nova/verify-account-failure',
        authentication: authenticationTypes.unauthenticated,
        modules: [],
    },
    '/nova/account-verified': {
        url: '/nova/account-verified',
        authentication: authenticationTypes.unauthenticated,
        modules: [],
    },
};
